/**
 * Checks whether the memberships cart contains any cart item for
 * a particular photo (by photo id).
 *
 * @param {Array<Object>} cart The cart.
 * @param {string} photoId The photo id.
 * @returns {boolean}
 */
export const membershipsCartContainsPhoto = (cart = [], photoId) => {
  return cart.some(item => item?.photo?.id === photoId);
};

/**
 * Checks whether all identities have been purchased
 *
 * @param {Object} albumMembershipGroup The AlbumMembershipGroup.
 * @returns {boolean}
 */
export const allIdentitiesPurchased = albumMembershipGroup => {
  if ((albumMembershipGroup?.identities?.length ?? 0) === 0) {
    return false;
  }
  return !albumMembershipGroup.identities.find(
    identity => identity.has_purchased_subscription === false,
  );
};

/**
 * Given an array of AlbumMembershipGroup identities it returns
 * the one with the highest number of matched photos.
 *
 * @param {Array} albumMembershipGroupIdentities - The AlbumMembershipGroup identities.
 * @returns {Object}
 */
export const getHighestMatchedPhotosIdentity = albumMembershipGroupIdentities => {
  if (
    !albumMembershipGroupIdentities ||
    albumMembershipGroupIdentities.length === 0
  ) {
    return undefined;
  }

  return albumMembershipGroupIdentities.reduce((max, identity) => {
    return identity.matched_photos_extended.total >
      max.matched_photos_extended.total
      ? identity
      : max;
  });
};
